// extracted by mini-css-extract-plugin
module.exports = {"colorThemeLightFontPrimaryFlipped":"#fff","component":"BS2JWvwfvUtrDoLC-ucUd","brand":"_1AnKuQXsHs6C3wPJRuzjWI","back":"_3u_Any8aewlJGt34GqFkWg","close":"_2OOaEk3Wcb_1oucs5_opbv"};